import logo from './logo.svg';
// import './App.css';
import './index.css';
import HeaderPage from './Components/HeaderPage';
import HomePage from './Pages/HomePage/HomePage';
import AjeetMiniCard from './Pages/AjeetMiniCard/AjeetMiniCard';
import AjeetMiniKeyFeatures from './Pages/AjeetMiniKeyFeatures/AjeetMiniKeyFeatures';
import AjeetMiniTecSpec from './Pages/AjeetMiniTecSpec/AjeetMiniTecSpec';
import AjeetMiniVideo from './Pages/AjeetMiniVideo/AjeetMiniVideo';
import FooterPage from './Components/FooterPage';

function App() {
  return (
    <div className="App">
<HeaderPage/>
<HomePage/>
<AjeetMiniCard/>
<AjeetMiniKeyFeatures/>
<AjeetMiniTecSpec/>
<AjeetMiniVideo/>
<br/>
<FooterPage/>
    </div>
  );
}

export default App;
